import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    successAddTemplate: false,
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case actions.CHANGE_SUCCESS_ADD_TEMPLATE_TEST:
            return { ...state, successAddTemplate: payload };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/add-template-test/add-template-test.reducer.js